import { Form, Input, InputNumber, Button, Row, Col, Space, Switch } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

import { DeviceProfileVendor } from "@chirpstack/chirpstack-api-grpc-web/api/device_profile_pb";

import { onFinishFailed } from "../helpers";

interface IProps {
  initialValues: DeviceProfileVendor;
  onFinish: (obj: DeviceProfileVendor) => void;
  disabled?: boolean;
}

function VendorForm(props: IProps) {
  const initialValues = {
    ...props.initialValues.toObject(),
    ouisList: props.initialValues.getOuisList(),
  };

  const onFinish = (values: DeviceProfileVendor.AsObject) => {
    const v = Object.assign(props.initialValues.toObject(), values);

    const out = new DeviceProfileVendor();
    out.setId(v.id);
    out.setName(v.name);
    out.setVendorId(v.vendorId);
    out.setOuisList((values.ouisList || []).filter(o => o && o.trim() !== ""));
    for (const elm of v.metadataMap) {
      out.getMetadataMap().set(elm[0], elm[1]);
    }
    out.setPublished(v.published);

    props.onFinish(out);
  };

  return (
    <Form layout="vertical" initialValues={initialValues} onFinish={onFinish} onFinishFailed={onFinishFailed}>
      <Form.Item label="Name" name="name" rules={[{ required: true, message: "Please enter a vendor name!" }]}>
        <Input disabled={props.disabled} />
      </Form.Item>
      <Form.Item
        label="LoRa Alliance Vendor ID"
        name="vendorId"
        tooltip="Numeric ID assigned by the LoRa Alliance. Leave at 0 if not applicable."
      >
        <InputNumber min={0} disabled={props.disabled} />
      </Form.Item>
      <Form.Item label="OUIs" tooltip="Organizationally Unique Identifiers used in DevEUIs assigned by this vendor.">
        <Form.List name="ouisList">
          {(fields, { add, remove }) => (
            <Space direction="vertical" style={{ width: "100%" }}>
              {fields.map(({ key, name, ...restField }) => (
                <Row gutter={8} key={key}>
                  <Col span={22}>
                    <Form.Item {...restField} name={name} noStyle>
                      <Input placeholder="e.g. a8404" disabled={props.disabled} />
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    {!props.disabled && <MinusCircleOutlined onClick={() => remove(name)} />}
                  </Col>
                </Row>
              ))}
              {!props.disabled && (
                <Button type="dashed" onClick={() => add("")} block icon={<PlusOutlined />}>
                  Add OUI
                </Button>
              )}
            </Space>
          )}
        </Form.List>
      </Form.Item>
      <Form.Item
        label="Published"
        name="published"
        valuePropName="checked"
        tooltip="When unpublished, this vendor and all its devices and templates are hidden from the public template API and the tenant template-picker. Editable regardless of source."
      >
        <Switch />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
}

export default VendorForm;
